require([
    "common/formUtils"
],
function (formUtils) {

    // execute Ajax request to fetch the product accessories content
    const productAccessoriesSelector = ".product-accessories"

    var postData = $(productAccessoriesSelector).data();
    formUtils.useToken(postData);

    $.ajax({
        type: "POST",
        url: "/customapi/Product/ProductAccessoriesContent",
        dataType: "json",
        data: postData,
        success: function (data) {
            if (data.status === "OK") {
                // put content on the page
                $(productAccessoriesSelector).html(data.content);
                // initialize accessories display based on currently selected variant
                window.Coria.reInitProductOptions();
                window.Coria.reInitQuantitySelectors();
                window.Coria.reInitAddToWishlistPopup();
            } else if (data.status === "ERROR") {
                console.error(data.message);
            }
        },
        error: function (jq, status, errorThrown) {
            console.error(status + ": " + errorThrown);
        },
        complete: function () {
            
        }

    });

});

define("ProductAccessories/main", function(){});

